export default __webpack_public_path__ + "static/media/penetratingshot5.c348f3c2.png";